import React from "react";

type FaqPanelLockedProps = {
  description: string;
};

export const FaqPanelLocked: React.FC<FaqPanelLockedProps> = ({
  description,
}) => (
  <div
    className="mx-auto max-w-lg py-8 sm:py-10"
    style={{ fontFamily: "'Nunito', system-ui, sans-serif" }}
  >
    <div className="rounded-[2rem] border-4 border-[#E5E5E5] bg-white p-8 text-center shadow-[0_8px_0_#D0D0D0] sm:p-10">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#FEF3C7] text-3xl ring-2 ring-[#F59E0B]/40">
        🔒
      </div>
      <h1 className="mb-2 text-2xl font-extrabold text-[#3C3C3C] sm:text-3xl">
        Almost there
      </h1>
      <p className="text-base font-semibold leading-relaxed text-[#777777]">
        {description}
      </p>
    </div>
  </div>
);
